export const sampleRoutes = [
    {
        path: '/sample',
        component: () => import('@/features/sample/views/SampleRouterView.vue'),
        children: [
            {
                path: '',
                redirect: { name: 'sample-data' },
            },
            {
                path: 'data',
                component: () => import('@/features/sample/views/SampleDataRouterView.vue'),
                children: [
                    {
                        path: '',
                        name: 'sample-data',
                        component: () => import('@/features/sample/views/SampleDataIndexView.vue'),
                    },
                    {
                        path: 'signal',
                        children: [
                            {
                                path: '',
                                redirect: { name: 'sample-data-signal-payer-data' },
                            },
                            {
                                path: 'payer-data',
                                name: 'sample-data-signal-payer-data',
                                component: () => import('@/features/signal/components/Signal.vue'),
                            },
                            {
                                path: 'market-overview',
                                name: 'sample-data-signal-market-overview',
                                component: () => import('@/features/signal/components/Signal.vue'),
                            },
                            {
                                path: 'peer-service-lines',
                                name: 'sample-data-signal-peer-service-lines',
                                component: () => import('@/features/signal/components/Signal.vue'),
                            },
                            {
                                path: 'peer-rates',
                                name: 'sample-data-signal-peer-rates',
                                component: () => import('@/features/signal/components/Signal.vue'),
                            },
                            {
                                path: 'hospital-data',
                                name: 'sample-data-signal-hospital-data',
                                component: () => import('@/features/signal/components/Signal.vue'),
                            },
                            {
                                path: 'hospital-peer-service-lines',
                                name: 'sample-data-signal-hospital-peer-service-lines',
                                component: () => import('@/features/signal/components/Signal.vue'),
                            },
                        ],
                    },
                    {
                        path: 'custom-pull',
                        name: 'sample-data-custom-pull',
                    },
                    {
                        path: 'methodology',
                        name: 'sample-data-methodology',
                    },
                ],
            },
            {
                path: 'custom-pull',
                component: () => import('@/features/sample/views/SampleCustomPullRouterView.vue'),
                children: [
                    {
                        path: '',
                        name: 'sample-custom-pull',
                        component: () => import('@/features/sample/views/SampleCustomPullIndexView.vue'),
                    },
                ],
            },
            {
                path: 'sign-up',
                name: 'sample-signup',
                component: () => import('@/features/sample/views/SampleSignUpView.vue'),
            },
        ],
    },
]
